<template>
    <div class="example pl32 pr32 pb32 pt32">
        <h1 class="mb32">
            非大事莫算，心诚则灵(选择要算的时间，比如我要在1月5号下午三点去做什么事情，想算算是否顺利，则选择2019-01-05
            15:00，点击天地无极就可以算出)
        </h1>
        <div class="time">
           <yd-datetime ref="datetime" v-model="datetime"></yd-datetime>
            <yd-button @click.native="search" class="mr8 ml32"
                >天地 无极</yd-button
            >
        </div>
        <p class="mt32 text-left">
            结果为：<span style="color:#f00;">{{ result }}</span>
        </p>
    </div>
    <!-- <div class="example">
          <a href="https://uri.amap.com/marker?position=120.007744,30.29473&name=梦想小镇">高德地图</a>
          <br>
          <a href="http://api.map.baidu.com/direction?origin=30.299541,120.011392&destination=30.29473,120.007744&mode=walking&region=杭州市&output=html">百度地图</a>
        </div> -->
</template>
<script>
export default {
    name: "example",
    data() {
        return {
            addressArr: [],
            visible: true,
            form: {},
            result: "",
            datetime: ""
        };
    },
    components: {},
    methods: {
        search() {
            if (!this.form.dateTime) {
                this.form.dateTime = new Date();
            } else {
                this.form.dateTime = new Date(
                    this.$moment(this.form.dateTime).format("YYYY-MM-DD HH:mm")
                );
            }
            let date = this.form.dateTime;
            let sum =
                date.getFullYear() + (date.getMonth() + 1) + date.getDate();

            if (date.getHours() >= 23 && date.getHours() < 1) {
                sum += 1; //子
            } else if (date.getHours() >= 1 && date.getHours() < 3) {
                sum += 2; //丑
            } else if (date.getHours() >= 3 && date.getHours() < 5) {
                sum += 3; //寅
            } else if (date.getHours() >= 5 && date.getHours() < 7) {
                sum += 4; //卯
            } else if (date.getHours() >= 7 && date.getHours() < 9) {
                sum += 5; //辰
            } else if (date.getHours() >= 9 && date.getHours() < 11) {
                sum += 6; //巳
            } else if (date.getHours() >= 11 && date.getHours() < 13) {
                sum += 7; //午
            } else if (date.getHours() >= 13 && date.getHours() < 15) {
                sum += 8; //未
            } else if (date.getHours() >= 15 && date.getHours() < 17) {
                sum += 9; //申
            } else if (date.getHours() >= 17 && date.getHours() < 19) {
                sum += 10; //酉
            } else if (date.getHours() >= 19 && date.getHours() < 21) {
                sum += 11; //戌
            } else if (date.getHours() >= 21 && date.getHours() < 23) {
                sum += 12; //亥
            }
            if (sum % 6 === 0) {
                this.result =
                    "大安事事昌，求财在坤方，失物去不远，宅舍保安康 行人身未动，病者主无妨，将军回田野，仔细更推详";
            } else if (sum % 6 === 1) {
                this.result =
                    "留连事难成，求谋日未明，官事凡宜缓，去者未回程 失物南方见，急讨方心称，更须防口舌，人口且平平";
            } else if (sum % 6 === 2) {
                this.result =
                    "速喜喜来临，求财向南行，失物申未午，逢人路上寻 官事有福德，病者无祸侵，田宅六畜吉，行人有信音";
            } else if (sum % 6 === 3) {
                this.result =
                    "赤口主口舌，官非切宜防，失物速速讨，行人有惊慌 六畜多作怪，病者出西方，更须防咀咒，诚恐染瘟皇";
            } else if (sum % 6 === 4) {
                this.result =
                    "小吉最吉昌，路上好商量，阴人来报喜，失物在坤方 行人即便至，交关甚是强，凡事皆和合，病者叩穷苍";
            } else if (sum % 6 === 5) {
                this.result =
                    "空亡事不祥，阴人多乖张，求财无利益，行人有灾殃 失物寻不见，官事有刑伤，病人逢暗鬼，解禳保安康";
            }
        },
        typeFilter(type) {}
    },
    mounted() {
        this.addressArr = [
            "110000",
            "110100",
            "110101",
            "110101001000",
            "110101001001"
        ];
    }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.example-map {
    width: 600px;
    height: 600px;
}
.example {
    height: 100vh;
    background: #fff;
    .map {
        width: 600px;
        height: 600px;
        background: rgba($color: #000000, $alpha: 0.1);
        margin: 100px auto;
    }
    .time {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>
